/**
 * User-facing metric blurbs — keep in lockstep with backend METRIC_DEFINITIONS_VERSION.
 */
export const METRIC_DEFINITIONS_VERSION = '2026.05.01'

const DEFINITIONS_BY_VERSION = {
  '2026.05.01': {
    mc_mean_primary:
      'Mean annualised return over the simulated horizon; equity denominator follows MC-α when a strategy breakdown is present.',
    mc_prob_threshold:
      'Fraction of paths exceeding the hurdle rate for this strategy / realism level.',
    mc_engine_y1_coc:
      'Year 1 pre-tax cash-on-cash from strategy_cashflow with jittered rent, voids, and mortgage rate.',
    gross_yield:
      'Annual gross rent (or STL gross) divided by purchase price — before operating costs and finance.',
    net_yield_after_finance:
      'Annual pre-tax cashflow after mortgage interest, divided by purchase price (not NOI yield).',
    noi_yield:
      'NOI before finance divided by purchase price (see Cashflow breakdown line items).',
  },
}

export function getMetricTooltip(version, key) {
  const v = version && DEFINITIONS_BY_VERSION[version] ? version : METRIC_DEFINITIONS_VERSION
  const bundle = DEFINITIONS_BY_VERSION[v] || DEFINITIONS_BY_VERSION[METRIC_DEFINITIONS_VERSION]
  return bundle[key] || ''
}
